import React, { useState, useRef } from "react";
import { Box, Button, Grid, Paper } from "@mui/material";
import CompactTextField from "src/components/CompactTextField";
import SugerenciaConDictado from "src/components/SugerenciaConDictado";
import { guardarSugerencia } from "src/api/sugerenciaService";
import { useNotifier } from "src/contexts/NotifierContext";
import { useAuth } from "src/contexts/AuthContext";

const BuzonSugerencias: React.FC = () => {
  const { user } = useAuth();
  const usuarioId = user?.idUsuario;

  const [mensaje, setMensaje] = useState("");
  const [interimText, setInterimText] = useState("");
  const [grabando, setGrabando] = useState(false);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const { showSuccess, showError } = useNotifier();
  const maxLength = 500;

  const enviar = async () => {
    if (!usuarioId) return showError("Usuario no encontrado");
    if (grabando) return;
    if (mensaje.trim().length < 5)
      return showError("La sugerencia debe tener al menos 5 caracteres.");

    try {
      const resp = await guardarSugerencia({
        idUsuario: usuarioId,
        mensaje,
      });

      if (resp.success) {
        showSuccess("Gracias por enviar tu sugerencia 🎉");
        setMensaje("");
      } else {
        showError(resp.errorMessage || "No se pudo guardar la sugerencia.");
      }
    } catch {
      showError("Error al conectar con el servidor.");
    }
  };

  // Mantiene cursor al final y combina mensaje + interinos
  const handleTextChange = (nuevoTexto: string) => {
    setMensaje(nuevoTexto);
    setTimeout(() => {
      if (textAreaRef.current) {
        textAreaRef.current.selectionStart =
          textAreaRef.current.selectionEnd = nuevoTexto.length + interimText.length;
      }
    }, 0);
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 550, mx: "auto", mt: 4 }}>
      <h2>Buzón de Sugerencias</h2>

      <Box sx={{ maxHeight: "55vh", overflowY: "auto", pb: 2 }}>
        <Grid container spacing={1}>
          {/* Dictado */}
          <Grid item xs={12}>
            <Box mt={1} mb={1} ml={1}>
              <SugerenciaConDictado
                text={mensaje}
                onChange={handleTextChange}
                onInterim={setInterimText}
                onRecordingStateChange={setGrabando}
              />
            </Box>
          </Grid>

          {/* Textarea */}
          <Grid item xs={12}>
            <CompactTextField
              label="Escribe tu sugerencia"
              multiline
              fullWidth
              minRows={4}
              inputRef={textAreaRef}
              value={mensaje + interimText} // Texto en tiempo real
              onChange={(e) => setMensaje(e.target.value)}
              inputProps={{ maxLength }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box ml={2} mt={-1}>
              {mensaje.length}/{maxLength} caracteres
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Botón ENVIAR */}
      <Box mt={2} display="flex" justifyContent="center" gap={1}>
        <Button
          variant="contained"
          onClick={enviar}
          disabled={grabando}
        >
          {grabando ? "Grabando..." : "Enviar"}
        </Button>
      </Box>
    </Paper>
  );
};

export default BuzonSugerencias;
